import { isEmpty } from "lodash";
import { getDaysInMonth } from "../helpers";
import fromHyphenatedString from "./fromHyphenatedString";

export default (rulesObject, datesOfMonth, selectedMonth) => {
  /**
   * @param {Object (<scheduleName: String, rules:Array[<Object>]>)} rulesObject an Object of rules created from the timeSpan,
   * rules will have a length of 1 or 2
   * @param {String} datesOfMonth datesOfMonth entry from the form
   * @param {String} selectedMonth month selected in the dropdown list section of the form.
   * @returns {rulesObject(<scheduleName: String, rules:Array[<Object>]>)}      rules object with the datesOfMonths included.
   */

  if (isEmpty(rulesObject)) {
    return null;
  }

  if (isEmpty(rulesObject)) {
    return null;
  }

  let hyphenatedDates = "";
  let dateList = [];

  if (datesOfMonth !== "" || datesOfMonth.includes("-")) {
    hyphenatedDates = datesOfMonth;
    dateList = fromHyphenatedString(hyphenatedDates);
  } else {
    const toDateArray = datesOfMonth.split(",");
    dateList = toDateArray.map((date) => Number(date));
  }

  const rulesArray = rulesObject.rules;
  if (rulesArray.length === 1) {
    dateList.map((dates) => rulesArray[0].month_days.push(dates));
  }

  if (rulesArray.length > 1) {
    // Given that the timeFrame <= 24 hours. All rules will be within the same month.
    rulesArray[0].months = [selectedMonth];
    // We update the months array because the month selected in the dropdown list takes precedence.
    rulesArray[1].months = [selectedMonth];

    for (let i = 0; i < dateList.length; i++) {
      if (rulesArray[0].endTime === "23:59") {
        rulesArray[0].month_days.push(dateList[i]);
        if (Number(dateList[i]) + 1 <= getDaysInMonth(selectedMonth)) {
          rulesArray[1].month_days.push(dateList[i] + 1);
        }
      }
    }
  }

  return rulesObject;
};
